export const fromEntriesPolyfill = (iterable: IterableIterator<any>) => {
  return [...iterable].reduce((obj, [key, val]) => {
    obj[key] = val;

    return obj;
  }, {});
};
